export default "{\n    \"label\": \"Grupos / Instalaciones\",\n    \"placeholder\": \"Seleccione grupos o instalaciones\"\n}"